'use client';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'ui/components/SelectV2/Select';
import { cltw } from 'ui';
import { AmplitudeActions, AmplitudeEvents } from 'whoop-analytics/lib/types';
import { tierLogoMap } from '@/lib/constants/images';
import type { MembershipTierWithTrial } from '@/lib/constants/maverick';
import { tierDisplayNameWithTrial } from '@/lib/constants/maverick';
import PriorityImage from '@/components/PriorityImage/PriorityImage';
import { useAnalytics } from '@/hooks/analytics';
interface TierFeatureListHeaderProps {
  tiers: MembershipTierWithTrial[];
  selectedTiers: MembershipTierWithTrial[];
  handleDropdownSelect: (tier: MembershipTierWithTrial, index: number) => void;
}
export default function TierFeatureListHeader({
  tiers,
  selectedTiers,
  handleDropdownSelect
}: TierFeatureListHeaderProps) {
  const {
    trackAmplitudeEvent
  } = useAnalytics();
  const isDropdownVisible = tiers.length > 2;
  const renderTierImage = (tier: MembershipTierWithTrial) => <PriorityImage alt={`membership-tier-logo-${tier}`} className='h-5 items-center justify-center' key={`${tier}-feature-list-header`} src={tierLogoMap[tier]} data-sentry-element="PriorityImage" data-sentry-component="renderTierImage" data-sentry-source-file="TierFeatureListHeader.tsx" />;
  return <>
      {/* Desktop header */}
      <div className={cltw('desktop:flex z-10 hidden h-full flex-row items-center justify-center gap-6 py-4', tiers.length === 2 ? 'w-[720px]' : 'w-full')} data-testid='tier-feature-list-header-desktop'>
        <div className='flex w-full flex-row gap-6'>
          {tiers.map(tier => renderTierImage(tier))}
        </div>
      </div>

      {/* Mobile header */}
      <div className='desktop:hidden sticky top-16 z-50 flex h-full w-screen flex-row items-center justify-center gap-6 bg-white py-2' data-testid='tier-feature-list-header-mobile'>
        <div className='flex w-[88%] flex-row gap-6'>
          {selectedTiers.map((tier, index) => {
          if (!isDropdownVisible) {
            return renderTierImage(tier);
          }
          // Filter out already selected tier so you can't compare the same tier on both dropdowns
          const filteredTiers = tiers.filter(t => t !== selectedTiers[1 - index]);
          return <Select key={`mobile-${tier}-select-tier-dropdown`} onValueChange={tier => {
            handleDropdownSelect(tier as MembershipTierWithTrial, index);
            trackAmplitudeEvent(AmplitudeEvents.ViewedJoinFlow, {
              action: AmplitudeActions.ChangedMembershipComparison,
              compare_table_changed_from: selectedTiers[index],
              compare_table_changed_to: tier
            });
          }} value={tier}>
                <SelectTrigger className='h-12 w-full rounded-2xl pr-0 text-xl font-bold' data-testid={`select-trigger-${tier}`}>
                  <SelectValue placeholder={tier} />
                </SelectTrigger>
                <SelectContent>
                  {filteredTiers.map(availableTier => <SelectItem className='text-xl font-bold' key={`${availableTier}-select-item`} value={availableTier}>
                      {tierDisplayNameWithTrial[availableTier]}
                    </SelectItem>)}
                </SelectContent>
              </Select>;
        })}
        </div>
      </div>
    </>;
}